import { ContainerComponent, wrap } from 'AppReact';
import internalState from './internalState';
import { PurchaseOrderCategoryBudgetWrapper, FlexCenterWrapper, Mt3, Mr2, Mr5, Mr8 } from 'wrappers';
import { BudgetProgressBar } from 'molecules';
import { Bullet, PrimaryTextXs } from 'atoms';

export const definition = ({
  controller: {},
  name: "CategoryBudget",
  initialProps: ({ category, currentAmount }) => ({ category, currentAmount }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Budgets',
      elements: [
        {
          component: wrap(Bullet, Mr2),
          name: 'BulletSpent',
          displayValue: ({ }) => '',
          displayState: ({ category }) => {
            let budgetExceeded = parseFloat(category?.spent ?? 0) > (category?.budget?.amount ?? 0);
            return { color: budgetExceeded ? '#981313' : '#1AAA60' }
          }
        },
        {
          component: wrap(PrimaryTextXs, Mr5),
          name: 'ThisMonth',
          displayValue: ({ category }) => `Spent this month - $${parseFloat(category?.spent).toFixed(2)}`,
        },
        {
          component: wrap(Bullet, Mr2),
          name: 'BulletCurrent',
          displayValue: ({ }) => '',
          displayState: ({ currentAmount, category }) => ({ color: (currentAmount + parseFloat(category?.spent)) > category?.budget?.amount ? '#FE6363' : '#61D197' })
        },
        {
          component: wrap(PrimaryTextXs, Mr5),
          name: 'ThisRequest',
          displayValue: ({ currentAmount }) => `This request - $${parseFloat(currentAmount).toFixed(2) || 'N/A'}`,
        },
        {
          component: wrap(Bullet, Mr2),
          name: 'BulletBudget',
          displayValue: ({ }) => '',
          displayState: ({ }) => ({ color: '#C7EFDA' })
        },
        {
          component: wrap(PrimaryTextXs, Mr5),
          name: 'ThisBudget',
          displayValue: ({ category }) => `budget - ${category?.budget ? parseFloat(category?.budget?.amount).toFixed(2) : 'N/A'}`,
        }
      ]
    },
    {
      component: wrap(wrap(BudgetProgressBar, Mt3), Mr8),
      name: 'ProgressBar',
      bindings: ({ category, currentAmount }) => ({ budget: category?.budget?.amount ?? 0, currentSpent: currentAmount ?? 0, spent: parseFloat(category?.spent) ?? 0 })
    }
  ],
})

export default wrap(ContainerComponent(definition), PurchaseOrderCategoryBudgetWrapper);